export const visit = (vm, at) => {
at({ "en": { "composer-data": { "email-metadata": { "subject-prefixes": { "reply": "Re: ", "forward": "Fwd: ", "conversation-with-agent": "Conversation with {{ agentName }}" } } } } });
};